import {AiChatLandingTipType} from './ai-chat-landing-tip-type';

export interface LandingTipConfig {
  type: AiChatLandingTipType;
  message: string;
  priority: number;
}

export const LANDING_TIP_CONFIGS: LandingTipConfig[] = [
  {type: AiChatLandingTipType.FIRST_MESSAGE_DETAILS, message: 'pmwjs_landing_tip_first_message_details', priority: 1},
  {type: AiChatLandingTipType.SHORT_TEXT, message: 'pmwjs_landing_tip_short_text', priority: 2},
  {type: AiChatLandingTipType.MENTION_STYLE, message: 'pmwjs_landing_tip_mention_style', priority: 3},
  {type: AiChatLandingTipType.ATTACH_INSPIRATION, message: 'pmwjs_landing_tip_attach_inspiration', priority: 4},
  {type: AiChatLandingTipType.EXACT_TEXT_QUOTES, message: 'pmwjs_landing_tip_exact_text_quotes', priority: 5},
  {type: AiChatLandingTipType.DESCRIBE_EDIT_ITEM, message: 'pmwjs_landing_tip_describe_edit_item', priority: 6},
  {type: AiChatLandingTipType.SPECIFY_ATTACHMENT_ACTION, message: 'pmwjs_landing_tip_specify_attachment_action', priority: 7},
  {type: AiChatLandingTipType.TEXT_CHANGES_QUOTES, message: 'pmwjs_landing_tip_text_changes_quotes', priority: 8},
  {type: AiChatLandingTipType.SPECIFY_OBJECT_LOCATION, message: 'pmwjs_landing_tip_specify_object_location', priority: 9},
  {type: AiChatLandingTipType.REFER_OBJECTS_IN_ATTACHMENTS, message: 'pmwjs_landing_tip_refer_objects', priority: 10},
  {type: AiChatLandingTipType.DESCRIBE_EXACT_CHANGES, message: 'pmwjs_landing_tip_describe_exact_changes', priority: 11},
];

/**
 * Greeting messages with the user's first name (use %s placeholder).
 */
export const GREETING_MESSAGES_WITH_NAME: string[] = [
  'pmwjs_landing_greeting_hey_name',
  'pmwjs_landing_greeting_hi_name_help',
  'pmwjs_landing_greeting_hi_name_awesome',
  'pmwjs_landing_greeting_hey_name_make',
];

/**
 * Greeting messages without a name.
 */
export const GREETING_MESSAGES_WITHOUT_NAME: string[] = [
  'pmwjs_landing_greeting_got_idea',
  'pmwjs_landing_greeting_make_great',
  'pmwjs_landing_greeting_what_create',
];
